import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.0833 2.91797H3.91666C3.36437 2.91797 2.91666 3.36568 2.91666 3.91797V5.88138C2.91666 6.12009 3.00205 6.35093 3.1574 6.53217L7.67591 11.8038C7.83126 11.985 7.91666 12.2158 7.91666 12.4546V16.8576C7.91666 17.5651 8.63118 18.0488 9.28805 17.7861L11.4547 16.9194C11.8344 16.7675 12.0833 16.3998 12.0833 15.9909V12.4546C12.0833 12.2158 12.1687 11.985 12.3241 11.8038L16.8426 6.53217C16.9979 6.35093 17.0833 6.12009 17.0833 5.88138V3.91797C17.0833 3.36568 16.6356 2.91797 16.0833 2.91797Z",
      stroke: "currentColor",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }